﻿import pixelPanZoom from './pixelpanzoom';
import VideoControls from './video-controls';

var colourSwatches = [];

var isTouch = false; //initiate as false
var iOS = false; //initiate as false
var iPhone = false; //initiate as false
var iPad = false; //initiate as false
var iPhoneHomeApp = false; //initiate as false
var touchStartPos = 0;
var clickEventStart = 'click';
var clickEventEnd = 'click';
var $vSM = 991; //Small Device Max Width (tablet)
var $vXS = 767; //Extra Small Max Width (mobile)
var DoSvgConvert;


$(document).ready(function () {

    // device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent.toLowerCase()) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isTouch = true;
    if (/ipad|iphone|ipod/g.test(navigator.userAgent.toLowerCase())) iOS = true;
    if (/iphone|ipod/g.test(navigator.userAgent.toLowerCase())) iPhone = true;
    if (/ipad/g.test(navigator.userAgent.toLowerCase())) iPad = true;
    if (!/safari/g.test(navigator.userAgent.toLowerCase()) && iPhone == true) iPhoneHomeApp = true;
    if (isTouch == true) {
        clickEventStart = 'touchstart';
        clickEventEnd = 'touchend';
        $("body").addClass("isTouch");
        $(window).resize(function () {
            $("body").removeClass("orientationPortrait").removeClass("orientationLandscape").addClass(($(window).width() > $(window).height()) ? "orientationLandscape" : "orientationPortrait");
        }).trigger('resize');
        if (iOS == true) { $("body").addClass("iOS"); }
        if (iOS == true && iPhone == true) { $("body").addClass("iPhone"); }
        if (iOS == true && iPad == true) { $("body").addClass("iPad"); }
        if (iPhoneHomeApp == true) { $("body").addClass("iPhoneHomeApp"); }
    }

    // Used for SEO to ensure all links with 'gatrack' onclick method fire GA Tracking
    $("a[onclick=gatrack]").on("click", function () {
        gtag('event', 'Hyperlink', {
            'event_category': $(this).text(),
            'event_label': $(this).attr("href")
        });
    });

    //Replace all SVG images with inline SVG
    DoSvgConvert = function () {
        var r = $.Deferred();

        $('img.svgConvert').each(function () {
            var $img = $(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            $.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                //Append the SVG filename to any SVG CSS classes that begin with "st" followed by a number. 
                //AB 21-05-18: IE doesn't like innerHTML with SVG's for whatever good reason, commenting out the following lines until a solution can be found
                //imgURLFileName = imgURL.split('\\').pop().split('/').pop();
                //imgURLFileName = imgURLFileName.substring(0, imgURLFileName.indexOf('.'));
                //$svg[0].innerHTML = $svg[0].innerHTML.replace(/([."])([sS][tT][\d]+?)([{"])/g, '$1$2_' + imgURLFileName + '$3');

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

            return r;
        });
    };
    DoSvgConvert();
});

$(document).ready(function ($) {

    $(".header__nav__item-level-0").each(function () {
        if ($(this).find(".header__nav__item-level-1").length > 0) {
            $(this).addClass("hasChildren");
        }
    });

    $(".header__nav__item-level-1").each(function () {
        if ($(this).find(".header__nav__item-level-2__item").length > 0) {
            $(this).addClass("hasChildren");
        }
    });

    if ($(window).width() > 1024) {
        $(".header__nav__item-level-0").hover(function () {
            $(".header__nav__item-level-0").removeClass("hover");
            $(this).addClass("hover");
            $(".header__nav__item-level-1").removeClass("hover");

            var firstItem = $(this).find(".header__nav__item-level-1").first();
            firstItem.addClass("hover");
            if (firstItem.attr("data-img") != "") {
                SetNavPromo($(this), $(this).find(".header__nav__promo-area"));
                SetNavPromo(firstItem, firstItem.find(".header__nav__promo-area"));
            }
            else {
                SetNavPromo($(this), $(this).find(".header__nav__promo-area"));
            }
        },
            function () {
                $(".header__nav__item-level-0").removeClass("hover");
            });

        $(".header__nav__item-level-1").hover(function () {
            $(".header__nav__item-level-1").removeClass("hover");
            $(this).addClass("hover");

            if ($(this).attr("data-img") != "") {
                SetNavPromo($(this), $(this).find(".header__nav__promo-area"));
            }
        });

        $(".header__nav__item-level-2__item").hover(function () {
            $(".header__nav__item-level-2__item").removeClass("hover");
            $(this).addClass("hover");
        });
    }

    else {
        $(".navBtn").on("click", function () {
            $(".header__nav").addClass("open");
            $("body").addClass("nav-open")
 
        });

        $(".header__nav__close-btn").on("click", function () {

            if ($(".header__nav").hasClass("level-2-open")) {
                $(".header__nav").removeClass("level-2-open");
                $(".header__nav__item-level-1.hasChildren").removeClass("clicked");
                $(this).html("Main menu");
            }

            else if ($(".header__nav").hasClass("level-1-open")) {
                $(".header__nav").removeClass("level-1-open");
                $(".header__nav__item-level-0.hasChildren").removeClass("clicked");
                $(this).html("Close");
            }
            else {
                $(".header__nav").removeClass("open");
                $("body").removeClass("nav-open")
            }
        });

        $(".header__nav__item-level-0.hasChildren").on("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
            $(this).addClass("clicked");
            $(".header__nav").addClass("level-1-open");
            var currentNode = $(this).find(".header__nav__item-level-0--link");
            var currentLink = currentNode.attr("href");
            var currentText = currentNode.html();
            $(".header__nav__clicked-link").attr("href", currentLink);
            $(".header__nav__clicked-link").html(currentText);
            $(".header__nav__close-btn").html("Main menu");
        });

        $(".header__nav__item-level-1").on("click", function (e) {
            if ($(this).hasClass("hasChildren")) {
                e.stopPropagation();
                e.preventDefault();
                $(this).addClass("clicked");
                $(".header__nav").addClass("level-2-open");
                var currentNode = $(this).find(".header__nav__item-level-1--link");
                var currentLink = currentNode.attr("href");
                var currentText = currentNode.html();
                $(".header__nav__close-btn").html($(".header__nav__clicked-link").html());
                $(".header__nav__clicked-link").attr("href", currentLink);
                $(".header__nav__clicked-link").html(currentText);
            }
            else {
                window.location.href = $(this).find(".header__nav__item-level-1--link").attr("href");
            }
        });

        $(".header__nav__item-level-2--link").on("click", function (e) {
            window.location.href = $(this).attr("href");
        });
    }

    $(".footer-links__title").on("click", function () {

        var footerTitle = $(this);
        var footerColParent = $(this).parent();
        var footerLinks = footerColParent.find(".footer-links__links");

        if (footerColParent.hasClass("on")) {
            footerColParent.removeClass("on");
        }
        else {
            $(".footer__top-flex__content-column").removeClass("on");
            footerColParent.addClass("on");
        }
    });

    function SetNavPromo(currentitem, currentpromo) {

        var image = currentitem.attr("data-img");
        var title = currentitem.attr("data-title");
        var buttonlink = currentitem.attr("data-link");
        var buttontext = currentitem.attr("data-link-text");

        currentpromo.each(function () {

            $(this).find(".header__nav__promo-area__promo").css("background-image", "url('" + image + "')");
            $(this).find(".header__nav__promo-area__promo-text").html(title);
            $(this).attr("href", buttonlink);
            $(this).find(".header__nav__promo-area__promo-link").html(buttontext);
        });


    }

    if ($(".banner-search__search-input").length > 0) {
        $(".banner-search__search-input")
            .autocomplete({
                source: function (request, response) {
                    $.ajax({
                        url: "/SiteFiles/WebServices/WebService.asmx/GetDevelopments",
                        data: "{ 'term': '" + request.term + "'}",
                        dataType: "json",
                        type: "POST",
                        contentType: "application/json; charset=utf-8",
                        success: function (data) {
                            response($.map(data.d, function (item) {
                                return {
                                    dev: item.split('|')[0],
                                    url: item.split('|')[1]
                                };
                            }));
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.log(errorThrown);
                        }
                    });
                },
                minLength: 1,
                focus: function (event, ui) {
                    event.preventDefault();
                    $(".banner-search__search-input").val(ui.item.dev);
                },
                select: function (event, ui) {
                    event.preventDefault();
                    $(this).val(ui.item.dev);
                    window.location.replace(ui.item.url);
                }
            })
            .data("ui-autocomplete")
            ._renderItem = function (ul, item) {
                return $("<li />")
                    .data("ui-autocomplete-item", item)
                    .append("<span>" + item.dev + "</span>")
                    .appendTo(ul);
            };

        if ($(window).width() < 1024) {
            $(".banner-search__search-input").attr("placeholder", "Please enter a location");
        }
    }

    AddBannerSearchFunctionality();
    AddInnerBannerSearchFunctionality();

    if ($(".slider-items").length > 0) {
        $(".slider-items").each(function () {
            var currentWidget = $(this).parent();
            var currentSlider = $(this);

            currentSlider.slick({
                autoplay: false,
                infinite: false,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                dots: true,
                appendDots: currentWidget.find(".slick-nav__bar"),
                prevArrow: currentWidget.find(".slick-nav__arrow--left"),
                nextArrow: currentWidget.find(".slick-nav__arrow--right")
            });
        });
    }

    if ($(".gallery-widget").length > 0) {
        $(".gallery-widget").each(function () {
            var currentWidget = $(this);
            var currentSlider = $(this).find(".gallery-widget__images");
            var currentSliderNumber = currentWidget.find(".gallery-widget__slide-current");
            var currentSliderThumb = currentWidget.find(".gallery-widget__slide-thumb");
            var currentMaxSlides = currentWidget.find(".gallery-widget__slide-max").html();
            var currentPercentage = 100 / currentMaxSlides;
            var leftToUse = 0;
            currentSliderThumb.css("width", currentPercentage + "%");
            currentSliderThumb.css("left", leftToUse + "%");

            currentSlider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                currentSliderNumber.html(nextSlide + 1);
                if ((nextSlide + 1) > 9) {
                    currentWidget.find(".gallery-widget__slide-zero").html();
                }
                else {
                    currentWidget.find(".gallery-widget__slide-zero").html("0");
                }
                leftToUse = currentPercentage * nextSlide;
                currentSliderThumb.css("left", leftToUse + "%");

            });

            currentSlider.slick({
                autoplay: false,
                infinite: false,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                dots: true,
                appendDots: currentWidget.find(".slick-nav__bar"),
                prevArrow: currentWidget.find(".slick-nav__arrow--left"),
                nextArrow: currentWidget.find(".slick-nav__arrow--right")
            });
        });
    }


    if ($(".related-content").length > 0) {
        $(".related-content").each(function () {
            var currentWidget = $(this);
            var currentSlider = $(this).find(".related-content__items");
            var currentSliderNumber = currentWidget.find(".related-content__slide-current");
            var currentSliderThumb = currentWidget.find(".related-content__slide-thumb");
            var currentMaxSlides = currentWidget.find(".related-content__slide-max").html();
            var currentPercentage = 100 / currentMaxSlides;
            var leftToUse = 0;
            currentSliderThumb.css("width", currentPercentage + "%");
            currentSliderThumb.css("left", leftToUse + "%");

            currentSlider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                currentSliderNumber.html(nextSlide + 1);
                if ((nextSlide + 1) > 9) {
                    currentWidget.find(".related-content__slide-zero").html();
                }
                else {
                    currentWidget.find(".related-content__slide-zero").html("0");
                }
                leftToUse = currentPercentage * nextSlide;
                currentSliderThumb.css("left", leftToUse + "%");

            });

            currentSlider.slick({
                autoplay: false,
                infinite: false,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                dots: true,
                appendDots: currentWidget.find(".slick-nav__bar"),
                prevArrow: currentWidget.find(".slick-nav__arrow--left"),
                nextArrow: currentWidget.find(".slick-nav__arrow--right")
            });
        });
    }

    if ($(".inner-banner__flex-side__images").length > 0) {
        $(".inner-banner__flex-side__images").each(function () {
            var currentWidget = $(this).parent();
            var currentSlider = $(this);

            currentSlider.on('afterChange', function (event, slick, currentSlide) {
                currentWidget.find(".inner-banner__nav-bar--current-slide").html("0" + (currentSlide + 1));
            });

            currentSlider.slick({
                autoplay: false,
                infinite: false,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: false,
                dots: true,
                appendDots: currentWidget.find(".slick-nav__bar"),
                prevArrow: currentWidget.find(".slick-nav__arrow--left"),
                nextArrow: currentWidget.find(".slick-nav__arrow--right"),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            arrows: false
                        }
                    }]
            });
        });
    }

    if ($(window).width() < 768) {
        if ($(".latest-news__items").length > 0) {
            $(".latest-news__items").each(function () {
                var currentWidget = $(this).parent();
                var currentSlider = $(this);

                currentSlider.slick({
                    autoplay: false,
                    infinite: false,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    dots: true,
                    appendDots: currentWidget.find(".slick-nav__bar"),
                });
            });
        }
        if ($(".dashboard__split-content").length > 0) {
            $(".dashboard__split-content").each(function () {
                var currentWidget = $(this).parent();
                var currentSlider = $(this);

                currentSlider.slick({
                    autoplay: false,
                    infinite: false,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    dots: true,
                    appendDots: currentWidget.find(".slick-nav__bar"),
                });
            });
        }
    }


    if ($(".banner-search").length > 0) {
        $(".banner-search").each(function () {
            if ($(this).find(".vimeo").length > 0) {
                $(this).addClass("bannerLoaded");
                DoLoadTopBannerVimeo($(this));
            }
        });
    }

    if ($(".intro-text__faded-text").length > 0) {
        $(".intro-text__faded-text").each(function () {
            var thisIsThis = $(this);
            $(document).on("scroll", function () {
                if (isInViewport(thisIsThis[0], 100, 0)) {
                    thisIsThis.css("right", getLeftPosition(thisIsThis[0]) + "%");
                }
            });
        });
    }

    $(".widget.imageZoom").each(function () {
        var currentItem = $(this);
        var currentButton = currentItem.find(".imageZoom__key-button");
        currentButton.on("click", function () {
            if (currentButton.parent().hasClass("closed")) {
                currentButton.parent().removeClass("closed");
                currentButton.find(".imageZoom__key-button__text-change").html("Collapse");

            }
            else {
                currentButton.parent().addClass("closed");
                currentButton.find(".imageZoom__key-button__text-change").html("Show");
            }
        });

        if ($(window).width() < 1024) {
            currentButton.parent().addClass("closed");
        }
    });

    $(".widget.floorplan.imageZoom").each(function () {
        var currentItem = $(this);
        var currentImage = $(this).find(".image img")[0];
        var currentButton = currentItem.find(".imageZoom__key-button");

        const pz = pixelPanZoom(currentImage, { zoomInButton: currentItem.find(".controls .zoomIn")[0], zoomOutButton: currentItem.find(".controls .zoomOut")[0], infoMessage: currentItem.find(".imageZoom__gestures-message")[0], maxScale: 5 });
        currentButton.on("click", function () {
            if (currentButton.parent().hasClass("closed")) {
                currentButton.parent().removeClass("closed");
                currentButton.find(".imageZoom__key-button__text-change").html("Collapse");

            }
            else {
                currentButton.parent().addClass("closed");
                currentButton.find(".imageZoom__key-button__text-change").html("Show");
            }
        });

        if ($(window).width() < 1024) {
            currentButton.parent().addClass("closed");
        }

    });

    if ($(".home-specification").length > 0) {
        $(".home-specification").each(function () {
            var currentWidget = $(this);
            var tabs = $(this).find(".home-specification__tab");
            var tabbedItems = $(this).find(".home-specification__tabbed-item");

            tabs.first().addClass("selected");
            tabbedItems.first().removeClass("home-specification__tabbed-item--hidden");
            $(".home-specification__tabs-mobile-value").html(tabs.first().html());

            currentWidget.find(".home-specification__tab").on("click", function () {
                tabs.removeClass("selected");
                $(this).addClass("selected");
                tabbedItems.addClass("home-specification__tabbed-item--hidden");
                currentWidget.find(".home-specification__tabs-mobile-value").html($(this).html());
                var currentIndex = $(this).parent().children().index(this);
                tabbedItems.get(currentIndex).classList.remove("home-specification__tabbed-item--hidden");
            });

            currentWidget.find(".home-specification__tabs-holder").on("click", function () {
                if ($(this).find(".home-specification__tabs").hasClass("open")) {
                    $(this).find(".home-specification__tabs").removeClass("open");
                }
                else {
                    $(this).find(".home-specification__tabs").addClass("open");
                }
            });
        });
    }

    if ($(".location-tabs").length > 0) {
        $(".location-tabs").each(function () {
            var currentWidget = $(this);
            var tabs = $(this).find(".location-tabs__tabs-heading");
            var tabbedItems = $(this).find(".location-tabs__tab");

            tabs.first().addClass("selected");
            tabbedItems.first().removeClass("location-tabs__tab--hidden");
            $(".location-tabs__tabs-mobile-value").html(tabs.first().html());

            currentWidget.find(".location-tabs__tabs-heading").on("click", function () {
                tabs.removeClass("selected");
                $(this).addClass("selected");
                tabbedItems.addClass("location-tabs__tab--hidden");
                currentWidget.find(".location-tabs__tabs-mobile-value").html($(this).html());
                var currentIndex = $(this).parent().children().index(this);
                tabbedItems.get(currentIndex).classList.remove("location-tabs__tab--hidden");
            });

            currentWidget.find(".location-tabs__tabs-holder").on("click", function () {
                if ($(this).find(".location-tabs__tabs-headings").hasClass("open")) {
                    $(this).find(".location-tabs__tabs-headings").removeClass("open");
                }
                else {
                    $(this).find(".location-tabs__tabs-headings").addClass("open");
                }
            });
        });
    }


    if ($(".plot-listing__plot").length > 0) {
        if ($(window).width() < 1024) {
            $(".plot-listing__plot").first().addClass("selected");
            $(".plot-listing__plot").first().find(".plot-listing__plot__tab").addClass("selected");
            $(".plot-listing__plot").first().find(".plot-listing__plot__info-holder").addClass("selected");
            $(".plot-listing__plot").on("click", function () {
                if (!$(this).hasClass("selected")) {
                    $(this).addClass("selected");
                    $(this).find(".plot-listing__plot__tab").addClass("selected");
                    $(this).find(".plot-listing__plot__info-holder").addClass("selected");
                }
                else {
                    $(this).removeClass("selected");
                    $(this).find(".plot-listing__plot__tab").removeClass("selected");
                    $(this).find(".plot-listing__plot__info-holder").removeClass("selected");
                }
            });
        }
    }

    if ($(".house-accordion").length > 0) {
        $(".house-accordion__tab--floor-plan").on("click", function () {
            $(".house-accordion .floor-plans").addClass("selected");
            $(".house-accordion__tab--floor-plan").addClass("selected");
            $(".house-accordion__tab--site-map").removeClass("selected");
            $(".house-accordion .imageZoom").removeClass("selected");
        });

        $(".house-accordion__tab--site-map").on("click", function () {
            $(".house-accordion .floor-plans").removeClass("selected");
            $(".house-accordion__tab--floor-plan").removeClass("selected");
            $(".house-accordion__tab--site-map").addClass("selected");
            $(".house-accordion .imageZoom").addClass("selected");
        });
    }

    if ($(".floor-plans").length > 0) {
        var tabs = $(this).find(".floor-plans__tab");
        var tabbedItems = $(this).find(".floor-plans__floor-plan");

        tabs.first().addClass("selected");
        $(".floor-plans__tabs-mobile-value").html(tabs.first().html());
        tabbedItems.first().addClass("selected");
        $(this).find(".floor-plans__tab").on("click", function (e) {
            e.stopPropagation();
            tabs.removeClass("selected");
            $(this).addClass("selected");
            tabbedItems.removeClass("selected");
            $(".floor-plans__tabs").removeClass("open");
            $(".floor-plans__tabs-mobile-value").html($(this).html());
            var currentIndex = $(this).parent().children().index(this);
            tabbedItems.get(currentIndex).classList.add("selected");
        });

        if ($(window).width() < 1024) {

            $(this).find(".floor-plans__tabs-holder").on("click", function () {
                if ($(this).find(".floor-plans__tabs").hasClass("open")) {
                    $(this).find(".floor-plans__tabs").removeClass("open");
                }
                else {
                    $(this).find(".floor-plans__tabs").addClass("open");
                }
            });
        }
    }

    if ($(document).find(".development-filter__filter-area").length > 0) {
        if ($(window).width() < 1024) {
            $(document).find(".development-filter__filter-title").on("click", function () {
                // console.log("eh");
                var clickedFilter = $(this).parent().parent();
                if (clickedFilter.hasClass("on")) {
                    clickedFilter.removeClass("on");
                }
                else {
                    clickedFilter.addClass("on");
                }

            });
        }
    }

    if ($(".faq-lister").length > 0) {
        $(".faq-lister__faq").on("click", function () {
            if ($(this).hasClass("open")) {
                $(this).removeClass("open");
            }
            else {
                $(this).addClass("open");
            }
        });
    }

    if ($(".news-listing__filter").length > 0) {
        SetupSwatches();

        $(document).find(".news-listing__filter").on("click", function () {
            var cats = $(document).find(".news-listing__filter__categories");
            if (cats.hasClass("hidden")) {
                cats.removeClass("hidden");
            }
            else {
                cats.addClass("hidden")
            }
        });
    }

    if ($(window).width() < 991) {
        if ($(".dashboard__docs").length > 0) {
            $(".dashboard__docs").each(function () {
                var currentWidget = $(this).parent();
                var currentSlider = $(this);

                currentSlider.slick({
                    autoplay: false,
                    infinite: false,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    dots: true,
                    appendDots: currentWidget.find(".slick-nav__bar"),
                });
            });
        }

    }

    $(".signUp .next").on("click", function () {
        $(this).parent().find("input[type=submit]").first().click();
    });

    $(".form-style__field input[type=text], .form-style__field textarea, .email-sign-up input[type=text]").on("focusout", function () {
        if ($(this).val().length > 0) {
            $(this).addClass("focused");
        }
    });

    $(document).find(".form-style__field select, .email-sign-up select").on("focusout", function () {
        // console.log($(this).prop('selectedIndex'));
        if ($(this).prop('selectedIndex') != 0) {
            $(this).addClass("has-value");

        }
    });

    $(".make-enquiry__button").on("click", function () {
        $(document).scrollTop($(".form-flex").first().position().top);
    });

    $(".control-group-inline select").each(function () {
        if ($(this).find("option").first().attr("selected") != "selected") {
            $(this).addClass("has-value");
        }
    });

    if ($(".get-in-touch-banner").length > 0) {
        var interestedin = GetParameterValues('interestedin');
        function GetParameterValues(param) {
            var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for (var i = 0; i < url.length; i++) {
                var urlparam = url[i].split('=');
                if (urlparam[0] == param) {
                    return urlparam[1];
                }
            }
        }

        if (interestedin) {
            $(document).scrollTop($(".form-flex").first().position().top);
        }
    }

    if ($(".account-docs").length > 0) {
        $(".dashboard__doc__accept-button__holder").on("click", function (e) {
            if ($(this).find(".button--greyed-out").length > 0) {
                e.preventDefault();
                e.stopPropagation();
                $(this).find(".dashboard__doc__accept-button__info").removeClass("dashboard__doc__accept-button__info--hidden");
            }
        });

        $(".dashboard__doc__accept-button__info").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).addClass("dashboard__doc__accept-button__info--hidden");
        });
    }

    /* START: Lazy load Google Maps if we're using it on the current page */
    // This essentially replaces an old implementation where we're just loading the following within the master footer.
    //  <script src="/SiteFiles/Js/map.js" type="text/javascript"></script>
    //  <script
    //    src="https://maps.googleapis.com/maps/api/js?key=AIzaSyArLoacxMnLTWH8kI1fKdsuiN3cvkBY-YI&callback=initMap" async>
    //  </script>
    var googleMaps = document.querySelectorAll('#map');

    googleMaps.forEach(googleMap => {

        var fnCallGoogleMaps = function () {
            const mapsApi = "https://maps.googleapis.com/maps/api/js?key=AIzaSyArLoacxMnLTWH8kI1fKdsuiN3cvkBY-YI&callback=initMap"
            const mapApiScript = document.querySelector(`script[src='${mapsApi}'`)

            if (!mapApiScript) {
                    var scriptMapsCode = document.createElement("script");
                    scriptMapsCode.setAttribute("type", "text/javascript");
                    scriptMapsCode.setAttribute("src", "/SiteFiles/Js/map.js");
                    scriptMapsCode.addEventListener('load', function () {
                        var scriptMapsAPI = document.createElement("script");
                        scriptMapsAPI.setAttribute("type", "text/javascript");
                        scriptMapsAPI.setAttribute("src", mapsApi);
                        document.body.appendChild(scriptMapsAPI);
                    });
                    document.body.appendChild(scriptMapsCode);
                }
             }

            if ('IntersectionObserver' in window) {
                var options = {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0.5
                };

                var observer = new IntersectionObserver(onIntersection, options);

                function onIntersection(entries) {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            fnCallGoogleMaps();
                            observer.unobserve(entry.target);
                        }
                    });
                }

                observer.observe(googleMap);
            } else {
                fnCallGoogleMaps();
            }
        

    })

  
    /* FINISH: Lazy load Google Maps if we're using it on the current page */

    if (document.querySelectorAll(".js-video-content").length > 0) {
        var vContent = document.querySelectorAll(".js-video-content");
        vContent.forEach(HandleVideoContent);
    }

    $(".js-development-location-btn").on("click", function () {
        var banner = $(this).closest(".js-development-banner");
        var map = banner.find(".js-development-map");
        var slider = banner.find(".js-development-banner-slider");
        if (map && map.hasClass("hidden")) {
            map.removeClass("hidden");
            slider.addClass("hidden");
        }
    });

    $(".js-development-banner-map-close").on("click", function () {
        var banner = $(this).closest(".js-development-banner");
        var map = banner.find(".js-development-map");
        var slider = banner.find(".js-development-banner-slider");
        if (map && !map.hasClass("hidden")) {
            slider.removeClass("hidden");
            map.addClass("hidden");
        }
    });

    var caseStudyReadMoreButtons = document.querySelectorAll(".js-case-study-read-more");

    caseStudyReadMoreButtons.forEach(function (btn) {
        btn.addEventListener("click", function (event) {
            var item = btn.closest(".js-case-study-item");
            if (item) {
                var image = item.querySelector(".js-case-study-image");
                var title = item.querySelector(".js-case-study-title");
                var quote = item.querySelector(".js-case-study-short-quote");
                if (image) {
                    image.classList.add("hide");
                }
                if (title) {
                    title.classList.add("hide");
                }
                if (quote) {
                    quote.classList.add("hide");
                }
                item.querySelector(".js-case-study-hover").classList.add("show");
                btn.classList.add("hide");
            }
        });
    });

    var caseStudyAlternativeItems = document.querySelectorAll(".js-case-study-item");

    caseStudyAlternativeItems.forEach(function (item) {
        item.addEventListener("mouseover", function (event) {
            if (window.innerWidth > 1023) {
                var image = item.querySelector(".js-case-study-image");
                var title = item.querySelector(".js-case-study-title");
                var quote = item.querySelector(".js-case-study-short-quote");
                const hoverContent = item.querySelector(".js-case-study-hover")
                let imgHeight = 0
         
                if (image) {
                    imgHeight = image.offsetHeight;
        
                }
                if (title) {
                    title.classList.add("hide");
                }
                if (quote) {
                    quote.classList.add("hide");
                }
                if (hoverContent) {
                    hoverContent.style.maxHeight = `${imgHeight}px`;
                }
                item.querySelector(".js-case-study-read-more").classList.add("hide");
            }
        });

        item.addEventListener("mouseout", function (event) {
            if (window.innerWidth > 1023) {
                var image = item.querySelector(".js-case-study-image");
                var title = item.querySelector(".js-case-study-title");
                var quote = item.querySelector(".js-case-study-short-quote");
                if (image) {
                    image.classList.remove("hide");
                }
                if (title) {
                    title.classList.remove("hide");
                }
                if (quote) {
                    quote.classList.remove("hide");
                }
                item.querySelector(".js-case-study-read-more").classList.remove("hide");
            }
        });
    });

    window.addEventListener("resize", function (ev) {
        caseStudyAlternativeItems.forEach(function (item) {
            var title = item.querySelector(".js-case-study-title");
            var quote = item.querySelector(".js-case-study-short-quote");
            if (title) {
                title.classList.remove("hide");
            }
            if (quote) {
                quote.classList.remove("hide");
            }
            item.querySelector(".js-case-study-read-more").classList.remove("hide");
            item.querySelector(".js-case-study-hover").classList.remove("show");
        });
    });

    let $reviewSliders = $(".js-review-slider");
    $reviewSliders.each(function (item) {
        var $slider = $(this);
        var $parent = $slider.parent();
        $slider.slick({
            infinite: false,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: false,
            dots: true,
            appendDots: $parent.find(".slick-nav__bar"),
            prevArrow: $parent.find(".slick-nav__arrow--left"),
            nextArrow: $parent.find(".slick-nav__arrow--right"),
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1.2
                    }
                }]
        });
    });
});

function SetupSwatches() {
    $(document).find(".news-listing__filter ul li").each(function () {
        var currentCat = $(this);
        var currentCatColour = $(this).find("span").attr("data-cat-colour");
        var currentHTML = $(this).html();
        var spanToCreate = "<span class='news-listing__filter__category-swatch' style='background-color: " + currentCatColour + "'></span>";
        $(this).html(spanToCreate + currentHTML);
        colourSwatches.push(currentCatColour);
    });
    // console.log(colourSwatches);
}

function RefreshSwatches() {
    // console.log(colourSwatches);
    var count = 0;
    $(document).find(".news-listing__filter ul li").each(function () {
        var currentHTML = $(this).html();
        var spanToCreate = "<span class='news-listing__filter__category-swatch' style='background-color: " + colourSwatches[count] + "'></span>";
        $(this).html(spanToCreate + currentHTML);
        count++;
    })
}
function getLeftPosition(node) {
    var rect = node.getBoundingClientRect();
    var rectTop = rect.top - 400;
    if (rectTop < 0) {
        return 0;
    }
    else {
        var rectTopAsPercentage = rectTop / 10;
        return rectTopAsPercentage;
    }

}

function isInViewport(node, overflowTop, overflowBottom) { //node must be a javascript elem, not a jQuery one. Use $(".element")[0] to pull vanilla elem from jQuery object
    var rect = node.getBoundingClientRect();
    return (
        (rect.height > 0 || rect.width > 0) &&
        rect.bottom >= -Math.abs(overflowBottom) &&
        rect.right >= 0 &&
        (rect.top - overflowTop) <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function setVideoFrameSize($banner, $iframe) {
    var extraPixels = 4; // This adds just a few extra pixels to avoid getting horrible white space around the edges of the iframe.
    var parentHeight = $banner.find(".banner-search__banner").height() + extraPixels;
    if (parentHeight > 0) {

        var width = $(window).width() + extraPixels;
        var height = (width * 9) / 16;

        if (height > parentHeight) {
            $iframe.width(width);
            $iframe.height((width * 9) / 16);

        }
        else {
            $iframe.width(parentHeight * 1.78);
            $iframe.height(parentHeight);
        }
    }
    else {
        var t = setTimeout(function () { setVideoFrameSize($banner, $iframe) }, 100);
    }
}

function DoLoadTopBannerVimeo() {
    var showVideo = true;
    var $banner = $(".banner-search");
    var $iframe = $banner.find("iframe").first();
    var started = false;

    if ($iframe.length > 0 && showVideo && $(window).width() > 991) {
        var player = new Vimeo.Player($iframe, { loop: true, background: true, autoplay: true, controls: false });
        player.setVolume(0);
        var slowTimeout = setTimeout(function () { if (!started) { started = true; player.unload(); $iframe.parent().remove(); console.log("Slow connection, aborting banner video"); } }, 7000);
        player.on('progress', function (data) {
            if (!started) {
                $banner.addClass("videoLoaded");
                $iframe.css("opacity", "");
            }
            started = true;
        });

        $(window).resize(function () {
            if (showVideo) {
                $banner.find(".banner-search__banner").css("height");
                setVideoFrameSize($banner, $iframe);

                setTimeout(function () { setVideoFrameSize($banner, $iframe); }, 500);
            }
        }).trigger('resize');
    }
    else {
        $iframe.parent().remove();
    }
}

function zoom(scale, isSmooth, currentController) {
    if (scale) {
        var transform = currentController.getTransform();
        var deltaX = transform.x;
        var deltaY = transform.y;
        var offsetX = scale + deltaX;
        var offsetY = scale + deltaY;

        if (isSmooth) {
            currentController.smoothZoom(offsetX, offsetY, scale);
        } else {
            currentController.zoomTo(offsetX, offsetY, scale);
        }
    }
}

//$(window).on("load", function () {
//    if ($("#pnlReportAProblemThankYou").length > 0) {
//        setTimeout(function () {
//            $("html, body").scrollTop($("#pnlReportAProblemThankYou").offset().top);
//        }, 500);
//    }
//});

function AddBannerSearchFunctionality() {
    if ($(document).find(".banner-search__search-btn").length > 0) {
        $(document).find(".banner-search__search-btn").on("click", function () {
            var searchVal = $(document).find(".banner-search__search-input").val();
            window.location.replace("/search/" + searchVal);
        });

        $(document).find(".banner-search__search-input").on('keyup', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                var searchVal = $(document).find(".banner-search__search-input").val();
                window.location.replace("/search/" + searchVal);
            }
        });
    }
}

function AddInnerBannerSearchFunctionality() {
    const btn = document.querySelector(".location-banner__search-btn");
    const inputs = document.querySelectorAll(".location-banner__search-input");

    inputs.forEach(input => {

        if (btn) {
            btn.addEventListener("click", function () {
                var searchVal = input.value;
                var typeVal = btn.dataset.type;
                window.location.replace("/search/" + searchVal + `?type=${typeVal}`);
            });
        }

        input.addEventListener('keyup', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                var searchVal = input.value;
                var typeVal = btn.dataset.type;
                window.location.replace("/search/" + searchVal + `?type=${typeVal}`);
            }
        });
    });
}

var prm = Sys.WebForms.PageRequestManager.getInstance();

prm.add_endRequest(function () {
    NewsletterSignup();
    //DoSvgConvert();
    AddInputWrappers();
    //RefreshSwatches();
    SetupSwatches();
    AddBannerSearchFunctionality();

    if ($(window).width() < 991) {
        if ($(".dashboard__docs").length > 0) {
            $(".dashboard__docs").each(function () {
                var currentWidget = $(this).parent();
                var currentSlider = $(this);

                currentSlider.slick({
                    autoplay: false,
                    infinite: false,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    dots: true,
                    appendDots: currentWidget.find(".slick-nav__bar"),
                });
            });
        }

    }
    if ($(document).find(".development-filter__filter-area").length > 0) {
        if ($(window).width() < 1024) {
            $(document).find(".development-filter__filter-title").on("click", function () {
                // console.log("eh");
                var clickedFilter = $(this).parent().parent();
                if (clickedFilter.hasClass("on")) {
                    clickedFilter.removeClass("on");
                }
                else {
                    clickedFilter.addClass("on");
                }

            });
        }
    }

    $(document).find(".news-listing__filter").on("click", function () {
        var cats = $(document).find(".news-listing__filter__categories");
        if (cats.hasClass("hidden")) {
            cats.removeClass("hidden");
        }
        else {
            cats.addClass("hidden")
        }
    });
    //if ($(".charCount").length) {
    //    updateCountdown();
    //    $('.charCount').change(updateCountdown);
    //    $('.charCount').keyup(updateCountdown);
    //}

    $("textarea.expanding.empty").on("load change", function () {
        $(this).toggleClass("empty", ($(this).val() === ''));
    });

    $(document).find(".form-style__field select").each(function () {
        if ($(this).prop('selectedIndex') != 0) {
            $(this).addClass("has-value");
        }
    });

    if ($(".plot-listing__plot").length > 0) {
        if ($(window).width() < 1024) {
            $(".plot-listing__plot").first().addClass("selected");
            $(".plot-listing__plot").first().find(".plot-listing__plot__tab").addClass("selected");
            $(".plot-listing__plot").first().find(".plot-listing__plot__info-holder").addClass("selected");
            $(".plot-listing__plot").on("click", function () {
                if (!$(this).hasClass("selected")) {
                    $(this).addClass("selected");
                    $(this).find(".plot-listing__plot__tab").addClass("selected");
                    $(this).find(".plot-listing__plot__info-holder").addClass("selected");
                }
                else {
                    $(this).removeClass("selected");
                    $(this).find(".plot-listing__plot__tab").removeClass("selected");
                    $(this).find(".plot-listing__plot__info-holder").removeClass("selected");
                }
            });
        }
    }

    if ($(".account-docs").length > 0) {
        $(".dashboard__doc__accept-button__holder").on("click", function (e) {
            if ($(this).find(".button--greyed-out").length > 0) {
                e.preventDefault();
                e.stopPropagation();
                $(this).find(".dashboard__doc__accept-button__info").removeClass("dashboard__doc__accept-button__info--hidden");
            }
        });

        $(".dashboard__doc__accept-button__info").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).addClass("dashboard__doc__accept-button__info--hidden");
        });
    }
    
});

function AddInputWrappers() {
    $(".form input[type=text], .form select, .form textarea").not("#AffordCalc.form .homeSearch input[type=text]").each(function () {
        if (!$(this).parent().is(".inputWrap")) {
            $(this).wrap("<div class='inputWrap'></div>");
        }
    });
}

function NewsletterSignup() {
    $(".signUp .next").click(function () {
        $(this).parent().find(".hiddenBtn").trigger("click");
    });
}

function NewsletterSignupNextStep(prevStep, nextStep) {
    if (prevStep === "two") {
        $(".step.one").addClass("hide");
        $(".steps .item.one").removeClass("active");
    }

    $(".step." + prevStep).addClass("hide");
    $(".step." + nextStep).removeClass("hide");

    $(".steps .item." + prevStep).removeClass("active");
    $(".steps .item." + nextStep).addClass("active");
}

function HandleVideoContent(vc) {
    //vc.addEventListener("click", function () {
    //    const bgVideo = vc.querySelector(".js-bg-video");
    //    const { videoId } = bgVideo.dataset;

    //    if (!videoId) return;

    //    const options = {
    //        id: videoId,
    //        loop: true,
    //        muted: true,
    //        controls: false
    //    };

    //    const player = new Player(bgVideo, options);
    //    const videoControls = new VideoControls(player, bgVideo.parentElement);
    //    videoControls.updateProgressBar();

    //    player
    //        .play()
    //        .then(() => {
    //            bgVideo.classList.add("is-active");
    //            $(this).find(".house-type-film__overlay").addClass("is-hidden");
    //            $(this).find(".video-controls").addClass("is-visible");

    //            videoLoaded = true;
    //        })
    //        .catch((error) => console.error(error));

    //    $(".house-type-film").on("click", ".js-video-controls-play-pause", function () {
    //        videoControls.handlePlayPause(this);
    //    });

    //    $(".house-type-film").on("click", ".js-video-controls-fullscreen", function () {
    //        videoControls.toggleFullScreen();
    //    });

    //    $(".house-type-film").on("click", ".js-video-controls-mute", function () {
    //        videoControls.toggleSound();
    //    });

    //});
}
